export default __webpack_public_path__ + "static/4_months-24370bcdbcb77259cccff86a3c412c7a.jpeg";